import React from "react";
import OperatorItem from "ComponentsUI/OperatorItem/OperatorItem";
import { Link } from "react-router-dom";
import { replaceStaticHost, webpTransformer } from "Helpers/ImageManager";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import { CDN_URL } from "Constants/CDN";

export default class OperatorItemContainer extends React.Component {
	generateOperatorUrl(data) {
		if (data) {
			return generateUrl(Routes.OperatorDetails.route, {
				operator: data.url_name,
				regionUrl: data.region.url,
			});
		}
		return "/";
	}

	generateOperatorTariffUrl(data) {
		const operatorUrl = this.generateOperatorUrl(data);

		return operatorUrl !== "/" ? `${operatorUrl}/ratesmobile` : operatorUrl;
	}

	generateOperatorTariffActionsUrl(data) {
		const operatorUrl = this.generateOperatorUrl(data);

		return operatorUrl !== "/" ? `${operatorUrl}/actions` : operatorUrl;
	}

	generateLogoPath(item) {
		return item.logo
			? replaceStaticHost(item.logo)
			: replaceStaticHost(`${CDN_URL}/images/404.png`);
	}

	render() {
		return (
			<OperatorItem
				{...this.props}
				linkComponent={<Link to={"/"} />}
				generateOperatorTariffUrl={this.generateOperatorTariffUrl}
				generateOperatorTariffActionsUrl={this.generateOperatorTariffActionsUrl}
				generateLogoPath={(item) => this.generateLogoPath(item)}
				generateOperatorUrl={(data) => this.generateOperatorUrl(data)}
				webpTransformer={webpTransformer}
			/>
		);
	}
}
